module.exports = __webpack_public_path__ + "img/investors-2-min.0018a99a.png";